import api from "./ApiClient";

const BASE_PATH = '/foodz/api/v1/gerenciamentoDeUsuario';

class UserService {
    static async getUsers() {
        const clientCode = sessionStorage.getItem('clientCode');
        const response = await api.get(
            `${BASE_PATH}/listarTodosUsuariosGerenciamento`,
            { params: { clientCode } }
        );
        return response.data;
    }

    static async createUser(user) {
        const response = await api.post(
            `${BASE_PATH}/adicionarUsuario`,
            user
        );
        return response.data;
    }

    static async updateUser(searchInput, client) {
        const response = await api.put(
            `${BASE_PATH}/atualizarUsuario`,
            client,
            { params: { searchInput } }
        );
        return response.data;
    }

    static async updateUserPassword(client) {
        const response = await api.put(
            `${BASE_PATH}/atualizarSenhaUsuario`,
            client,
        );
        return response.data;
    }

    static async deleteUser(searchInput) {
        const response = await api.delete(
            `${BASE_PATH}/removerUsuario/${searchInput}`,
        );
        return response.data;
    }

}

export default UserService;